module.exports = __webpack_public_path__ + "img/building.c76934ff.jpg";